import { render, staticRenderFns } from "./ApexMedicalChart.vue?vue&type=template&id=51c3cc44&scoped=true"
import script from "./ApexMedicalChart.vue?vue&type=script&lang=js"
export * from "./ApexMedicalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3cc44",
  null
  
)

export default component.exports